import React from "react";
import { Link } from "react-router-dom";
import { FaHome, FaInfoCircle, FaEnvelope, FaCommentAlt, FaSignInAlt, FaSignOutAlt, FaUserPlus, FaTimes, FaShoppingCart } from "react-icons/fa";
import "./Sidebar.css";

const Sidebar = ({ toggleSidebar, isAuthenticated, handleLogout }) => {
  return (
    <div className="sidebar">
      {/* Close Button */}
      <button onClick={toggleSidebar} className="close-btn">
        <FaTimes />
      </button>

      {/* Sidebar Links with Icons */}
      <ul className="sidebar-menu">
        <li>
          <Link to="/" onClick={toggleSidebar} className="sidebar-link">
            <FaHome /> Home
          </Link>
        </li>
        <li>
          <Link to="/about-us" onClick={toggleSidebar} className="sidebar-link">
            <FaInfoCircle /> About
          </Link>
        </li>
        <li>
          <Link to="/contact-us" onClick={toggleSidebar} className="sidebar-link">
            <FaEnvelope /> Contact
          </Link>
        </li>
        <li>
          <Link to="/feedback" onClick={toggleSidebar} className="sidebar-link">
            <FaCommentAlt /> Feedback
          </Link>
        </li>
        <li>
          <Link to="/cart" onClick={toggleSidebar} className="sidebar-link">
            <FaShoppingCart /> Your Cart
          </Link>
        </li>
        {isAuthenticated ? (
          <li>
            <button onClick={handleLogout} className="sidebar-link logout-btn">
              <FaSignOutAlt /> Logout
            </button>
          </li>
        ) : (
          <>
            <li>
              <Link to="/login" onClick={toggleSidebar} className="sidebar-link">
                <FaSignInAlt /> Login
              </Link>
            </li>
            <li>
              <Link to="/register" onClick={toggleSidebar} className="sidebar-link">
                <FaUserPlus /> Register
              </Link>
            </li>
          </>
        )}
      </ul>
    </div>
  );
};

export default Sidebar;